<template>
  <div>
    <vs-card>
      <a-tabs default-active-key="1">
        <a-tab-pane key="1" tab="Upcoming">
          <vs-tabs>
            <vs-tab label="All">
              <div class="con-tab-ejemplo">
                Home
              </div>
            </vs-tab>
            <vs-tab label="Due This Week">
              <div class="con-tab-ejemplo">
                Service
              </div>
            </vs-tab>
            <vs-tab label="Due Today">
              <div class="con-tab-ejemplo">
                login
              </div>
            </vs-tab>
            <vs-tab label="Due Tomorrow">
              <div class="con-tab-ejemplo">
                Disabled
              </div>
            </vs-tab>
            <vs-tab label="Overdue">
              <div class="con-tab-ejemplo">
                Lorem ipsum dolor sit amet
              </div>
            </vs-tab>
          </vs-tabs>
<!--          <a-tabs default-active-key="1" class="ml-5">-->
<!--            <a-tab-pane key="1" tab="All">-->
<!--              Content of Tab Pane 1-->
<!--            </a-tab-pane>-->
<!--            <a-tab-pane key="2" tab="Due This Week" force-render>-->
<!--              Content of Tab Pane 2-->
<!--            </a-tab-pane>-->
<!--            <a-tab-pane key="3" tab="Due Today">-->
<!--              Content of Tab Pane 3-->
<!--            </a-tab-pane>-->
<!--            <a-tab-pane key="4" tab="Due Tomorrow">-->
<!--              Content of Tab Pane 3-->
<!--            </a-tab-pane>-->
<!--            <a-tab-pane key="5" tab="Overdue">-->
<!--              Content of Tab Pane 3-->
<!--            </a-tab-pane>-->
<!--          </a-tabs>-->
        </a-tab-pane>
        <a-tab-pane key="2" tab="Completed" force-render>
          Content of Tab Pane 2
        </a-tab-pane>
        <a-tab-pane key="3" tab="Lists">
          Content of Tab Pane 3
        </a-tab-pane>
        <a-tab-pane key="4" tab="Feeds">
          Content of Tab Pane 3
        </a-tab-pane>
      </a-tabs>
    </vs-card>
    <vs-card class="py-5 mt-10">
      <div class="container mx-auto text-center">
        <img src="../../../public/task.svg" alt="">
        <h2>You haven't created any tasks.</h2>
        <p class="text-base font-medium">
          Click here or use the button in the top right to create a new task.
        </p>
        <vs-button color="primary" type="filled" class="font-bold" @click="addTask">Add Tasks</vs-button>
      </div>
    </vs-card>
  </div>

</template>

<script>
  export default {
    name:"AddTAsk",
    methods:{
      addTask(){
        this.$router.push('/task/add')
      }
    }
  }
</script>


<style>
  /*.ant-tabs-bar.ant-tabs-top-bar:nth-child(1){*/
  /*  border-bottom: 0 !important;*/
  /*}*/
  .vs-tabs--ul{
    box-shadow: none !important;
  }
</style>
